 <template>
	<div>
		<div class="container">
			<div class="d-flex d-flex justify-content-between">
				<a class="btn btn-outline-secondary my-1" @click="window.history.back();">Zurück</a>
				<h3 class="my-0 py-2">Inventur</h3>
				<!--4011846009498-->
			</div>
			<div class="input-group input-group-lg pb-1">
				<input
					type="text"
					style="text-align: right;"
					class="form-control"
					placeholder="EAN"
					required
					v-model="entry.ean"
					ref="ean"
					onclick="this.select()"
					@keypress.enter="quantityClicked()"
				/>
			</div>
			<div class="input-group input-group-lg pb-1">
				<input
					id="qty"
					type="text"
					style="text-align: right;"
					class="form-control"
					placeholder="Menge"
					ref="quantity"
					v-model="entry.quantity"
					@click="quantityClicked"
				/>
			</div>
			<div class="input-group input-group-lg pb-1">
				<input
					type="text"
					style="text-align: right;"
					class="form-control"
					placeholder="Lagerplatz"
					required
					v-model="entry.stockyard"
					onclick="this.select()"
					@keypress.enter="save()"
				/>
			</div>
			<div class="py-2">
				<button
					type="button"
					class="input-group-append btn btn-lg btn-primary btn-block input-sm mb-1 float-right"
					style="padding-top: 5px"
					@click="save()"
				>
					<span class="icon icon-checkmark mx-auto"></span>
				</button>
			</div>
			<modal-error-component v-model="modalError"></modal-error-component>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			entry: {
				ean: null,
				quantity: null,
				stockyard: null
			},
			modalError: {
				show: false,
				message: "unpopulated",
				error: "unpopulated",
				title: "unpopulated"
			}
		};
	},
	methods: {
		quantityClicked() {
			if (this.entry.quantity == null || this.entry.quantity == "") {
				this.entry.quantity = 1;
			}
			Vue.nextTick(() => {
				this.$refs.quantity.select();
			});
		},
		save() {
			if (this.entry.ean == "" || this.entry.ean == null) {
				this.modalError = {
					show: true,
					message: "EAN muss angegeben werden.",
					error: "",
					title: "Speichervorgang"
				};
				return;
			}
			if (this.entry.quantity == "" || this.entry.quantity == null) {
				this.modalError = {
					show: true,
					message: "Menge muss angegeben werden.",
					error: "",
					title: "Speichervorgang"
				};
				return;
			}
			if (this.entry.stockyard == "" || this.entry.stockyard == null) {
				this.modalError = {
					show: true,
					message: "Lagerplatz muss angegeben werden.",
					error: "",
					title: "Speichervorgang"
				};
				return;
			}
			axios.post("/stocktaking", this.entry).then(response => {
				console.log("response: " + JSON.stringify(response));
				this.entry = {
					ean: null,
					quantity: null,
					stockyard: null
				};
				this.$refs.ean.focus();
			}).catch(function(error) {
				this.modalError = {
					show: true,
					message: "Änderungen wurden aufgrund eines Fehlers verworfen.",
					error: "",
					title: "Speichervorgang"
				};
			});
		}
	},
	mounted() {
		this.$refs.ean.focus();
	}
};
</script>
